<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      v-if="loading"
      d-flex
      justify-center    
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary" 
      />
    </v-flex>
    <v-flex x12>
      <v-card
        id="visitorContent"
        class="max-shadow"
      >
        <v-layout
          column
          wrap
        >
          <v-toolbar
            height="64"
            flat
            color="white"
          >
            <v-btn
              icon
              @click="$router.back()"
            >
              <v-icon color="iconColor">
                arrow_back
              </v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ visitor.name }}
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <!-- <v-btn
                  :disabled="!visitor.agreementSigned"
                  color="primary"
                  flat
                  large
                  @click="getAgreement"
                >
                  <v-icon>get_app</v-icon>agreement
                </v-btn> -->
              <v-btn
                flat
                large
                color="primary"
                @click="deleteVisitorDialog = true"
              >
                Delete
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-tabs
            v-model="active"
            class="px-2"
            color="primary"
            dark
            slider-color="yellow"
            grow
          >
            <v-tab
              v-for="tab in tabs"
              :key="tab"
            >
              {{ tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items :value="active">
            <v-tab-item
              :value="0"
            >
              <v-layout
                row
                wrap
                class="py-3"
              >
                <span class="px-2">
                    &nbsp;
                </span>
                <avatar
                  :src="visitor.photoUri"
                  :text="visitor.name"
                  :size="120"
                />
                <v-layout
                  column
                  wrap
                >
                  <div class="px-4 py-2">
                    <v-icon
                      color="iconColor"
                      class="px-3"
                    >
                      phone
                    </v-icon>
                    <span class="subheading">
                      +91  {{ visitor.phone }}
                    </span>
                  </div>
                  <div class="px-4 py-1">
                    <v-icon
                      color="iconColor"
                      class="px-3"
                    >
                      mail
                    </v-icon>
                    <span class="subheading">
                      {{ visitor.email }}
                    </span>
                  </div>
                  <div class="px-4 py-2">
                    <v-icon
                      color="iconColor"
                      class="px-3"
                    >
                      domain
                    </v-icon>
                    <span class="subheading">
                      {{ visitor.company }}
                    </span>
                  </div>
                </v-layout>
              </v-layout>
            </v-tab-item>
            <v-tab-item
              :value="1"
            >
              <v-flex xs12>
                <v-toolbar
                  flat
                  color="white"
                  height="48"
                >
                  <v-spacer />
                  <v-toolbar-items>
                    <search-widget
                      v-model="search"
                    />
                    <date-picker
                      v-model="selectedMonth"
                      :max="maxMonth"
                      type="month"
                    />
                  </v-toolbar-items>
                </v-toolbar>
                <v-data-table
                  id="visitorProfileTable"
                  :headers="visitorsHeaders"
                  :items="visitorLog.slice().reverse()"
                  :pagination.sync="pagination"
                  :search="search"
                  :loading="loading"
                  item-key="id"
                  no-data-text="No visitor is added"
                  class="px-3 pb-2"
                  disable-initial-sort
                >
                  <v-progress-linear
                    slot="progress"
                    color="primary"
                    indeterminate
                  />
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <tr
                      class=" row-border"
                    >
                      <td
                        class="tablePadding"
                        style="width: 20px"
                      >
                        {{ getIndex(props.index + 1) }}
                      </td>
                      <td
                        class="text-xs-left tablePadding"
                        style="width: 40px"
                      >
                        <avatar
                          :size="40"
                          :src="props.item.photoUri"
                          :text="props.item.name"
                        />
                      </td>
                      <td class="text-xs-left tablePadding">
                        {{ props.item.hostName }}
                      </td>
                      <td class="text-xs-left tablePadding">
                        {{ props.item.visitorType }}
                      </td>
                      <td class="text-xs-left tablePadding">
                        {{ millisToDateTimeStr(props.item.checkInDate) }}
                      </td>
                      <td class="text-xs-left tablePadding">
                        {{ millisToDateTimeStr(props.item.checkOutDate) }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-results">
                    <p class="text-xs-center">
                      Your search for <span class="font-weight-bold subheading">
                        {{ search }}
                      </span> found no results.
                    </p>
                  </template>
                </v-data-table>
              </v-flex>
            </v-tab-item>
          </v-tabs-items>
        </v-layout>
      </v-card>
      <v-dialog
        v-model="editVisitorDialog"
        lazy
        max-width="600px"
      >
        <edit-visitor
          :visitor="deepClone(visitor)"
          @update="visitorUpdated"
          @cancel="editvisitorDialog = false" 
        />
      </v-dialog>
      <v-dialog
        v-model="deleteVisitorDialog"
        lazy
        max-width="600px"
      >
        <v-card class="max-shadow">
          <v-card-title primary-title>
            <div class="headline">
              Delete {{ visitor.name }}
            </div>
          </v-card-title>
          <v-card-text>
            <div class="subheading">
              Do you want to delete <strong>{{ visitor.name }}</strong>?
              Visitor account will be deleted permanently from the Vizmo server
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              color="primary"
              @click.stop="deleteVisitorDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              flat
              color="primary"
              @click.stop="deleteVisitor"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="0"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          flat
          @click.native="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';

import * as moment from 'moment';

import { database } from '@/firebase';

import DatePicker from '@/components/common/DatePicker';
import avatar from '@/components/common/Avatar';
import SearchWidget from '@/components/common/SearchWidget';
import EditVisitor from './EditVisitor';

export default {
  name: 'Visitor',
  components: {
    'date-picker': DatePicker,
    avatar,
    EditVisitor,
    'search-widget': SearchWidget
  },
  props: {
    vid: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      visitor: {},
      visitorsHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
          width: '10px',
          class: ['tablePadding']
        },
        {
          text: 'Photo',
          value: 'photo',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Host',
          value: 'host',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Purpose',
          value: 'purpose',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Check In',
          value: 'checkIn',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Check Out',
          value: 'checkOut',
          align: 'left',
          class: ['tablePadding']
        }
      ],
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      loading: true,
      selectedMonth: '',
      dateFormat: 'YYYY-MM',
      maxMonth: '',
      startAt: '',
      endAt: '',
      visitorLog: [],

      active: null,
      tabs: ['profile', 'visitor log'],

      editVisitorDialog: false,
      deleteVisitorDialog: false,
      disableVisitorDialog: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary',

      firebaseListeners: []
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    },
    logRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      // return null if the location ID is not yet set
      if (!lid) return null;

      return database.ref(`/vms/${lid}/visitors_data/${this.vid}/visitor_log`);
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (!val) return;
        this.fetchVisitor();
      },
      immediate: true
    },

    logRef: {
      handler(val) {
        if (!val) return;

        this.firebaseListeners.forEach(listenerFunc => {
          val.off('value', listenerFunc);
        });

        this.fetchVisitorLog();
      },
      immediate: true
    },

    selectedMonth: {
      handler(val) {
        if (!val) return;
        this.startAt = moment(val)
          .startOf('month')
          .toISOString();
        this.endAt = moment(val)
          .endOf('month')
          .toISOString();

        if (!this.logRef) return;
        this.firebaseListeners.forEach(listenerFunc => {
          this.logRef.off('value', listenerFunc);
        });
        this.fetchVisitorLog();
      }
    }
  },
  created() {
    const date = moment();
    this.startAt = date.startOf('month').toISOString();
    this.endAt = date.endOf('month').toISOString();
    this.selectedMonth = date.format(this.dateFormat);
    this.maxMonth = date.format(this.dateFormat);
  },
  beforeDestroy() {
    // unsubscribe all firebase listeners
    this.firebaseListeners.forEach(listenerFunc => {
      this.logRef.off('value', listenerFunc);
    });
  },
  methods: {
    fetchVisitor() {
      const path = `vms/${this.locationId}/visitors/${this.vid}`;
      database
        .ref(path)
        .once('value')
        .then(visitorSnapshot => {
          if (!visitorSnapshot) return;
          const visitor = visitorSnapshot.val();
          visitor.id = this.vid;
          this.visitor = visitor;
          this.loading = false;
        });
    },

    fetchVisitorLog() {
      const log = this.logRef
        .orderByChild('checkInDate')
        .startAt(this.startAt)
        .endAt(this.endAt)
        .on('value', visitorLogSnapshot => {
          if (visitorLogSnapshot) {
            const log = visitorLogSnapshot.val();
            const logArray = this._toArray(log);
            this.visitorLog = logArray;
          }
        });
      this.firebaseListeners.push(log);
    },

    deepClone(obj) {
      return _cloneDeep(obj);
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    millisToDateTimeStr(millis) {
      if (millis) {
        return moment(millis).format('DD MMM h:mm A');
      }
      return '';
    },

    getIndex(index) {
      const { page, rowsPerPage } = this.pagination;
      return index + (page - 1) * rowsPerPage;
    },

    visitorUpdated() {
      this.fetchvisitor();
      this.editVisitorDialog = false;
    },

    // getAgreement() {
    //   const path = `${this.$store.state.profile.cid}/${
    //     this.locationId
    //   }/visitors`;
    //   storage
    //     .ref(path)
    //     .child(`agreements/${this.vid}.pdf`)
    //     .getDownloadURL()
    //     .then(url => {
    //       const anchorElement = document.createElement('a');
    //       anchorElement.setAttribute('href', url);
    //       anchorElement.click();
    //     })
    //     .catch(() => {});
    // },

    deleteVisitor() {
      this.deleteVisitorDialog = false;
      const path = `vms/${this.locationId}/visitors/${this.vid}`;
      database
        .ref(path)
        .set(null)
        .catch(error => {
          this.snackbarMessage = error;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });
      this.$router.back();
    }
  }
};
</script>

<style>
.profile {
  max-width: 300px;
  min-width: 300px;
}
#visitorContent {
  height: calc(100vh - var(--toolbar-height));
  overflow-y: scroll;
}
#visitorProfileTable .v-table__overflow {
  height: calc(100vh - 324px);
  overflow-y: scroll;
}
</style>

